<!-- 旅游信箱  mjs -->
<template>
 <div class=" travelServe mailboxContainer">
    <banner/>
    <!-- <div class="crumbs-1">
        <div class="container">
          <a href="/show/index">首页</a>
          <span>&gt;</span>
          <a href="#">旅游信箱</a>
        </div>
    </div> -->
    <crumbs />

    <div class="container ">
        <div class="leftPart pb100 fl" >
          <div class="uploadImg publish" v-loading="updateloading">
            <textarea
            class="mailtext"
              type="textarea"
              rows="2"
              :placeholder="placeholdertext"
              v-model="text">
            </textarea>
            <el-upload
              action
              class="uploadBox"
              multiple
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="handleSucc"
              :on-exceed = "overUpload"
              :on-change="changstatus"
              :http-request="upLoadimg"
              ref="uploads"
               :limit=3
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
            <div class="submitAll" @click="submitAll">提交</div>
          </div>

          <!-- 下面是信箱内容 -->
          <div class="allmail">{{ mailtitle }}</div>
          <div class="mailBoxList">

              <div class="mailItem clearfix" v-for="item in liuyanList" :key="item.id">
                <div class="photo" >
                  <img :src="getImage(item.portrait)"  alt="">
                </div>
                <div class="mailItemRg pb10">
                  <div class="name">{{item.releaseMan}}</div>
                  <div class="time"> {{item.crtTime.split(' ')[0]}}</div>
                  <div class="des">{{item.title}}</div>
                  <div class="img" id="img" v-if="item.image !=='' && item.image !== undefined">
                    <img  preview="0" :src="val" v-for="(val,i) in item.image.split(',')" :key="i">
                  </div>
                  <div class="reply" v-if="item.reply !== '' && item.reply !== undefined ">
                    <div> <span>回复：</span>{{item.reply}}</div>
                  </div>
                </div>
              </div>

          </div>

           <!-- 分页器 -->
          <el-pagination
            :page-size="20"
            :pager-count="5"
            layout="prev, pager, next"
            :total="total"
            background
            @current-change="currentChange"
            class="pagemodel1">
          </el-pagination>
        </div>

        <!-- 右侧问题列表 -->
        <div class="rightPart fr">
          <div class="norpro">常见问题</div>
          <div class="questionList">

              <div class="questionItem" v-for="item in issuelist" :key="item.id">

                <i></i>
                <p>{{item.issue}}</p>
                <p class="hiddenCont">{{item.settle}}</p>
                  <span slot="reference" @click="hidenBox($event)">[显示全部]</span>
               <div class="hidenBox becNone">
                  <div><span>问题：</span>{{item.issue}}</div>
                  <div><span>解答：</span>{{item.settle}}</div>
               </div>
              </div>

          </div>
        </div>
    </div>
 </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import {addmail, getliuyan, getIssue, uploads} from '@/api/mailbox/index'
export default {
  name: 'mailbox',
  components: {
    crumbs,
    banner
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      text: '',
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      total: 0,
      liuyanparams: {
        page: 1,
        limit: 5,
        menuId: ''
      },
      liuyanList: [],
      issueparams: {
        page: 1,
        limit: 50,
        menuId: ''
      },
      issuelist: [],
      menuId: '',
      params: [],
      departmentCode: '',
      imgstring: '',
      imgarr: [],
      hiddenFlag: false,
      List: [],
      placeholdertext: '说说你的想法，限50个字',
      mailtitle: '全部信箱',
      updateloading: false
    }
  },
  created () {
    this.departmentCode = this.$cookie.get('museumCode')
    this.menuId = this.$route.query.columnId
    this.liuyanparams.menuId = this.$route.query.columnId
    this.issueparams.menuId = this.$route.query.columnId
    this.getLiuyans()
    this.getIssuelist()
  },
  watch: {
    adSlot (val) {
      if (val) {
        this.List = val
        this.getData()
      }
    }
  },
  computed: {
    adSlot () {
      return this.$store.state.adSlot.list
    }
  },
  mounted () {
    if (this.$store.state.adSlot.list.length !== 0) {
      this.List = this.$store.state.adSlot.list
      this.getData()
    }
  },
  methods: {
    getData () {
      this.List.forEach(item => {
        if (item.slotCode === 'mailboxconfig') {
          if (item.adDetails !== undefined && item.adDetails !== '') {
            item.adDetails.forEach(items => {
              if (parseInt(items.adLink) === parseInt(this.$route.query.columnId)) {
                if (items.adCode === 'placeholder') {
                  this.placeholdertext = items.adName
                }
                if (items.adCode === 'mailtitle') {
                  this.mailtitle = items.adName
                }
              }
            })
          }
        }
      })
    },
    upLoadimg (param) {
      console.log(param)
      this.params.push(param)
    },
    getImgs () {
      this.updateloading = true
      const paramsData = new FormData()
      this.params.forEach((it, index) => {
        paramsData.append('file', it.file)
      })
      // console.log(paramsData);
      uploads(paramsData).then(res => {
        // console.log(res)
        this.imgarr = []
        res.data.data.forEach(item => {
          this.imgarr.push(item.http)
        })
        this.imgstring = this.imgarr.join(',')
      })
    },
    changstatus (file, fileList) {
      console.log(file, fileList)
    },
    submitAll () {
      if (this.params.length !== 0) {
        this.getImgs()
      }

      setTimeout(() => {
        var subparams = {
          title: this.text,
          menuId: this.menuId,
          image: this.imgstring,
          departmentCode: this.$cookie.get('museumCode')
        }
        if (subparams.title === '') {
          this.$message({
            message: '内容不能为空',
            type: 'warning'
          })
        } else {
          addmail(subparams).then(res => {
            console.log(res)
            if (res.data.rel === true) {
              this.updateloading = false

              this.$alert('上传成功', '', {
                confirmButtonText: '确定',
                callback: () => {
                  this.$message({
                    type: 'success',
                    message: '成功'
                  })
                  this.$refs.uploads.clearFiles()
                  this.params = []
                  this.text = ''
                  this.getLiuyan()
                }

              })
            }
          })
        }
      }, 1000)
    },
    getLiuyans () {
      getliuyan(this.liuyanparams).then(res => {
        console.log(res, 'liuyan')
        this.liuyanList = res.data.data.rows
        this.total = res.data.data.total
      })
    },
    getIssuelist () {
      getIssue(this.issueparams).then(res => {
        console.log(res, 'issue')
        this.issuelist = res.data.data.rows
      })
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPG2 = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning('只支持jpg或png格式图片')
      }
      if (!isLt5M) {
        this.$message.warning('请上传5MB以内的图片!')
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M
    },
    handleRemove (file, fileList) {
      // console.log(file, fileList);
      this.params.forEach((item, index) => {
        if (item.file === file.raw) {
          this.params.splice(index, 1)
        }
      })
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleSucc (response, file, fileList) {
      console.log(file, fileList)
    },
    overUpload () {
      this.$message('最多上传三张图片')
    },

    currentChange (val) {
      this.liuyanparams.page = val
      this.getLiuyans()
    },
    hidenBox (e) {
      console.log(e.currentTarget.nextSibling.nextSibling)
      e.currentTarget.nextSibling.nextSibling.classList.toggle('becNone')
    },
    //  默认头像
    getImage (val) {
      if (val === undefined || val === '') {
        return require('@/assets/common/icon/icon-default-avatar.png')
      } else {
        return val
      }
    }
  }
}

</script>

<style lang='scss' scoped>
@import "../../assets/common/scss/travleServes.scss";
/deep/.mailtext {
  resize: none;
  width: 100%;
  padding-top: 3px;
}
.questionItem{
  position: relative;
}

.hidenBox{
  width: 250px;
  height: auto;
  padding: 5px;
  border: 1px solid #0da78f;
  border-radius: 5px;
  div{
    span{
      font-size: 18px;
      font-weight: bold;
    }
  }
}
.becNone{
  display: none;
}
 .uploadBox{
   height: 148px;
    &>>>.el-upload--picture-card{
      width: 33px;
      height: 26px;
      border: none;
      background-color: rgba(255,255,255,0 );
      position: absolute;
      right: 10px;
      top: 10px;
       background: url('~@/assets/common/images/icon-pic.png') center no-repeat;
        background-size: 100% 100%;
      .el-icon-plus{
        &::before{
          content: none;
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/mailbox/list.vue